import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';
import { useSubstate } from 'use-substate';

import { selectAuth, selectUserId } from 'core/Store/auth/selectors';

export default function useAuth() {
  const [auth] = useSubstate(selectAuth);
  const [userId] = useSubstate(selectUserId);

  useEffect(() => {
    if (userId) {
      Sentry.configureScope(scope => scope.setUser({ id: `${userId}` }));
    } else {
      Sentry.configureScope(scope => scope.clear());
    }
  }, [userId]);

  return auth;
}
